import GlobalMetricCards from "../../../../../global/GlobalMetricCards";

export default function MembershipListMetricsSection({ items, loading }) {
  return (
    <section className="vml-metrics">
      <GlobalMetricCards
        items={items}
        loading={loading}
        ariaLabel="Volunteer memberships metrics"
      />
    </section>
  );
}
